// Extracts time from "2025-09-09 08:51:04"
export const getTime = (timestamp) => {
    const localTimestamp = convertUtcToLocal(timestamp);
    const timeText = localTimestamp.split(' ')[1]; // "08:51:04"
    const [hours, mins] = timeText.split(':');
    let h = parseInt(hours, 10);
    const amPm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12; // convert to 12-hour format
    return `${h}:${mins} ${amPm}`;
};

// Normalizes "2024-05-14T21:46:23.000Z" -> "2024-05-14 21:46:23"
// If already in "YYYY-MM-DD HH:MM:SS" format, returns as-is.
export const formatIsoTimestamp = (timestamp) => {
    if (!timestamp) return '';

    const raw = String(timestamp);
    if (raw.includes('T')) {
        return raw
            .replace('T', ' ')
            .replace('Z', '')
            .split('.')[0];
    }

    return raw;
};

// Helper for "YYYY-MM-DD"
const splitDate = (date) => {
    const [year, month, day] = date.split('-').map((x) => parseInt(x, 10));
    return { day, month, year };
};

// Returns Today / Yesterday / date
export const getDate = (timestamp) => {
    const localTimestamp = convertUtcToLocal(timestamp);
    const date = localTimestamp.split(' ')[0]; // "2025-09-09"
    const dateObj = splitDate(date);

    const now = new Date();
    const todayStr = now.toISOString().split('T')[0]; // "2025-09-09"
    const todayObj = splitDate(todayStr);

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    const yesterdayStr = yesterday.toISOString().split('T')[0];
    const yesterdayObj = splitDate(yesterdayStr);

    if (
        todayObj.year === dateObj.year &&
        todayObj.month === dateObj.month &&
        todayObj.day === dateObj.day
    ) {
        return 'Today';
    }
    if (
        yesterdayObj.year === dateObj.year &&
        yesterdayObj.month === dateObj.month &&
        yesterdayObj.day === dateObj.day
    ) {
        return 'Yesterday';
    }

    return formatDateToReadable(date.replace(',', '')); // fallback "25 Dec 2025"
};

// Convenience helper for UI: returns normalized dateTime + the derived date and time strings.
export const getDisplayDateTimeParts = (timestamp) => {
    const normalized = formatIsoTimestamp(timestamp);
    if (!normalized) {
        return { dateTime: '', date: '', time: '' };
    }

    return {
        dateTime: normalized,
        date: getDate(normalized),
        time: getTime(normalized),
    };
};

// Converts "2025-09-09 08:51:04" (UTC) → same format in local time
export const convertUtcToLocal = (utcTimestamp) => {
    // Replace space with 'T' to make it ISO compatible
    const utcIso = utcTimestamp.replace(' ', 'T') + 'Z';
    const date = new Date(utcIso);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const mins = String(date.getMinutes()).padStart(2, '0');
    const secs = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${mins}:${secs}`;
};

// Converts "2025-12-25" → "25 Dec 2025"
export const formatDateToReadable = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' }); // e.g., "Dec"
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
};

export const getCurrentUTCDateTime = () => {
    const now = new Date();

    const year = now.getUTCFullYear();
    const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(now.getUTCDate()).padStart(2, '0');
    const hours = String(now.getUTCHours()).padStart(2, '0');
    const minutes = String(now.getUTCMinutes()).padStart(2, '0');
    const seconds = String(now.getUTCSeconds()).padStart(2, '0');

    const utcFormattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return utcFormattedDate;
};
